module.exports = __webpack_public_path__ + "img/logo.aac4a3d2.png";